import { axiosInstance } from "@/lib/api/client";
import { TranslatableEnum } from "@rumble-it/common-lib/types/models/TranslatableEnum.interface";

export const getDamageFromDirections = async () =>
  axiosInstance
    .get<TranslatableEnum[]>(`/dossiers/damage-from-direction`)
    .then((response) => response.data);
